(() => {
  const languageNames = { da: 'Dansk', de: 'Deutsch', en: 'English' };
  const defaultLanguage = (country) => {
    if (country === 'DK') return 'da';
    if (['DE', 'AT', 'CH'].includes(country)) return 'de';
    return 'en';
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-anio-localization][data-native-language-defaults]').forEach((fields) => {
      if (fields.dataset.initialized) return;
      const country = fields.querySelector('[data-localization-country]');
      const language = fields.querySelector('[data-localization-language]');
      if (!country || !language) return;
      fields.dataset.initialized = 'true';
      let explicitLanguage = false;

      language.addEventListener('change', () => { explicitLanguage = true; });
      country.addEventListener('change', () => {
        if (explicitLanguage) return;
        const target = defaultLanguage(country.value);
        if (!Array.from(language.options).some((option) => option.value === target)) {
          // Available languages describe the current market. A newly selected
          // country can have a different published default at the destination.
          const option = document.createElement('option');
          option.value = target;
          option.lang = target;
          option.textContent = languageNames[target];
          language.appendChild(option);
        }
        language.value = target;
      });
      fields.closest('form')?.addEventListener('reset', () => { explicitLanguage = false; });
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
